import { supabase } from "@/lib/supabase";

export interface PublicShopData {
    name: string;
    description?: string;
    address?: string;
    city?: string;
    banner_url?: string;
    logo_url?: string;
    rating?: number;
    reviews?: number;
    time_ranges?: any;
    instagram?: string;
    phone?: string;
    performances?: Array<{
        id: string;
        price: number;
        duration: number;
        name: string;
        category_id: number;
        category: {
            name: string;
        };
    }>;
    gallery?: Array<{
        id: number;
        image_url: string;
    }>;
}

export const getPublicShopData = async (shopId: string): Promise<PublicShopData | null> => {
    // 1. Fetch shop basic info
    const { data: shop, error: shopError } = await supabase
        .from('Shops')
        .select(`
            name,
            description,
            address,
            city,
            banner_url, 
            logo_url,
            rating, 
            reviews, 
            time_ranges,
            instagram,
            phone
        `)
        .eq('id', shopId)
        .single();

    if (shopError || !shop) {
        console.error("Error fetching public shop data:", shopError);
        return null; // Return null instead of throwing to handle it gracefully in the UI
    }

    // 2. Fetch popular performances
    const { data: performances } = await supabase
        .from('Performances')
        .select(`
            id,
            price,
            duration,
            name,
            category_id,
            Categories (
                name
            )
        `)
        .eq('shop_id', shopId)
        .eq('is_active', true)
        .limit(4);

    // 3. Fetch gallery
    const { data: gallery } = await supabase
        .from('ShopGallery')
        .select('id, image_url')
        .eq('shop_id', shopId)
        .order('created_at', { ascending: false })
        .limit(3);

    const formattedPerformances = performances?.map(p => ({
        id: p.id,
        price: p.price,
        duration: p.duration,
        name: p.name,
        category_id: p.category_id,
        category: {
            name: (p.Categories as any)?.name || ''
        }
    })) || [];

    return {
        ...shop,
        performances: formattedPerformances,
        gallery: gallery || []
    } as PublicShopData;
};
